import { render, staticRenderFns } from "./BalanceTDB.vue?vue&type=template&id=557c34f3&scoped=true"
import script from "./BalanceTDB.vue?vue&type=script&lang=js"
export * from "./BalanceTDB.vue?vue&type=script&lang=js"
import style0 from "./BalanceTDB.vue?vue&type=style&index=0&id=557c34f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c34f3",
  null
  
)

export default component.exports